import { ChangeEvent, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { RequirementListType } from 'types/kodawari';

/**
 * 募集・採用情報に関するカスタムフック
 * @param initialRequirementList
 * @returns 募集・採用情報の値と更新する関数を含むオブジェクト
 */
export const useRequirements = (
  initialRequirementList: RequirementListType[]
) => {
  const [requirementList, setRequirementList] = useState<RequirementListType[]>(
    initialRequirementList
  );

  const selectedRequirementList = requirementList
    .filter(({ isChecked }) => isChecked)
    .map(({ value }) => value);

  // チェック状態更新処理
  const updateIsCheckedRequirementList = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const checkedList = requirementList.map((item) => {
      if (item.value !== event.target.value) return item;

      return {
        ...item,
        isChecked: event.target.checked,
      };
    });

    setRequirementList(checkedList);

    return checkedList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  };

  // 求人件数更新処理
  const updateRequirementListJobCount = (
    requirementsJobCountList: JobCountDetailResponse[] | undefined
  ) => {
    setRequirementList((pre) =>
      pre.map((item) => ({
        ...item,
        jobCount: findJobCount(requirementsJobCountList, item.value),
      }))
    );
  };

  // チェック状態クリア処理
  const clearIsCheckedRequirementList = () => {
    const checkedList = requirementList.map((item) => {
      return {
        ...item,
        isChecked: false,
      };
    });
    setRequirementList(checkedList);
  };

  return {
    requirementList,
    selectedRequirementList,
    updateIsCheckedRequirementList,
    updateRequirementListJobCount,
    clearIsCheckedRequirementList,
  };
};
